import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=5b5c8fac&scoped=true&"
import script from "./teacher.vue?vue&type=script&lang=js&"
export * from "./teacher.vue?vue&type=script&lang=js&"
import style0 from "./teacher.vue?vue&type=style&index=0&id=5b5c8fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c8fac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BackLink: require('/vercel/path0/components/general/BackLink.vue').default,RegisterForm: require('/vercel/path0/components/auth/RegisterForm.vue').default,Card: require('/vercel/path0/components/general/Card.vue').default})
